import { Link, useNavigate } from 'react-router-dom';

import { FiLogOut } from 'react-icons/fi';

import { useAuth } from '../../hooks/auth';
import { useSudoku } from '../../games/Sudoku/SudokuContext';
import { useTimerContext } from '../../hooks/TimerContext';
import { formatClock } from '../../games/core/session/time';
import { HeaderMenu } from '../HeaderMenu';

import { BiMenu, BiMenuAltLeft } from 'react-icons/bi';

import logoWhite from '../../assets/img/logoWhite.png';
import logo from '../../assets/img/logo.png';

import {
  Container,
  MidContent,
  RightContent,
  Button,
  DesktopHeader,
  MobileHeader,
  Header,
} from './styles';
import { FaStopwatch, FaTrophy } from 'react-icons/fa';
import { IoTriangleSharp } from 'react-icons/io5';
import { Dropdown, Menu } from 'antd';
import { useState } from 'react';
import { useThemeApp } from '../../hooks/theme';

import palavrasCruzadaIcon from '../../assets/icons/palavras-cruzadas-icon.png';
import cacaPalavrasIcon from '../../assets/icons/caca-palavras-icon.png';
import rebusIcon from '../../assets/icons/rebus-icon.png';
import sudokuIcon from '../../assets/icons/sudoku-icon.png';
import quizIcon from '../../assets/icons/quiz-icon.png';
import wordleIcon from '../../assets/icons/wordle-icon.png';

interface ItemMenuProps {
  buttonText: string;
  buttonFunctions?: () => void;
}

enum GamesType {
  'SUDOKU',
  'REBUS',
  'QUIZ',
  'CACAPALAVRAS',
  'CRUZADAS',
  'WORDLE',
}

interface GameHeaderProps {
  /** Relógio do jogo (useGameSession). Sem ele, usa o TimerContext (Wordle). */
  seconds?: number;
  maxScore: number;
  currentScore?: number;
  menuItems: ItemMenuProps[];
  type: 'SUDOKU' | 'REBUS' | 'QUIZ' | 'CACAPALAVRAS' | 'CRUZADAS' | 'WORDLE';
}

interface GameTypeProps {
  name: string;
  headerColor: string;
  hoverColor: string;
  darkHoverColor: string;
  counterColor: string;
  darkCounterColor: string;
  icon: string;
  bottomColor?: string;
}

export const GameHeader = ({
  maxScore,
  menuItems,
  type,
  currentScore = -1,
  seconds,
}: GameHeaderProps) => {
  const navigate = useNavigate();

  const { logOut, user } = useAuth();
  const timer = useTimerContext();
  const clock = formatClock(seconds ?? timer.time);
  const { score } = useSudoku();

  const { isDark } = useThemeApp();
  const gamesProps: GameTypeProps[] = [
    {
      name: 'SUDOKU',
      headerColor: '#D1A14C',
      hoverColor: '#D1A14C',
      darkHoverColor: '#7f4788',
      counterColor: '#000',
      darkCounterColor: '#000',
      icon: sudokuIcon,
    },
    {
      name: 'REBUS',
      headerColor: '#000',
      hoverColor: '#9FA7F7',
      darkHoverColor: '#7f4788',
      counterColor: '#3d4347',
      darkCounterColor: '#222324',
      icon: rebusIcon,
    },
    {
      name: 'QUIZ',
      headerColor:
        'linear-gradient(90deg, rgba(127,71,136,1) 4%, rgba(84,173,72,1) 50%, rgba(84,173,72,1) 100%)',
      hoverColor: '#7f4788',
      darkHoverColor: '#7f4788',
      counterColor: '#222324',
      darkCounterColor: '#222324',
      icon: quizIcon,
      bottomColor: '#54ad48',
    },
    {
      name: 'CAÇA-PALAVRAS',
      headerColor: '#9FA7F7',
      hoverColor: '#D1A14C',
      darkHoverColor: '#D1A14C',
      counterColor: '#222324',
      darkCounterColor: '#000',
      icon: cacaPalavrasIcon,
    },
    {
      name: 'PALAVRAS CRUZADAS',
      headerColor: '#7f4788',
      hoverColor: '#7f4788',
      darkHoverColor: '#7f4788',
      counterColor: '#000',
      darkCounterColor: '#000',
      icon: palavrasCruzadaIcon,
    },
    {
      name: 'WORDLE',
      headerColor: '#d6d6d6',
      hoverColor: '#D1A14C',
      darkHoverColor: '#D1A14C',
      counterColor: '#000',
      darkCounterColor: '#000',
      icon: wordleIcon,
    },
  ];

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const items = menuItems.map((item) => {
    return {
      label: item.buttonText,
      key: item.buttonText,
      onClick: item.buttonFunctions,
    };
  });

  const menuDropdownItems = <Menu items={items} />;

  return (
    <Container>
      <DesktopHeader>
        <HeaderMenu />
        <MidContent>
          <img src={isDark ? logo : logoWhite} alt="logo" />
        </MidContent>
        {user ? (
          <RightContent>
            <Button buttonColor="purple" onClick={logOut}>
              <p>Sair</p>
              <FiLogOut size={20} />
            </Button>
          </RightContent>
        ) : (
          <RightContent>
            <Link to="/cadastrar">
              <Button buttonColor="purple">
                <p>Cadastrar</p>
              </Button>
            </Link>
            <Link to="/">
              <Button buttonColor="green">
                <p>Fazer Login</p>
              </Button>
            </Link>
          </RightContent>
        )}
      </DesktopHeader>
      <MobileHeader>
        <Header
          counterColor={
            isDark
              ? gamesProps[GamesType[type]].darkCounterColor
              : gamesProps[GamesType[type]].counterColor
          }
          headerColor={gamesProps[GamesType[type]].headerColor}
          isWordle={gamesProps[GamesType[type]].name === 'WORDLE'}
        >
          <span>
            <IoTriangleSharp onClick={() => navigate('/')} />

            <p>
              <FaStopwatch size={20} />
              {clock}
            </p>

            <p>
              <FaTrophy size={20} />
              {currentScore === -1 ? score : currentScore}/{maxScore}
              PTS
            </p>

            <Dropdown
              overlay={menuDropdownItems}
              trigger={['click']}
              onVisibleChange={() => setIsMenuOpen((oldValue) => !oldValue)}
            >
              {!isMenuOpen ? (
                <BiMenu
                  style={{
                    transform: 'revert',
                    height: '22px',
                    width: '22px',
                  }}
                />
              ) : (
                <BiMenuAltLeft
                  style={{
                    transform: 'revert',
                    height: '22px',
                    width: '22px',
                  }}
                />
              )}
            </Dropdown>
          </span>
          <p>
            <img src={gamesProps[GamesType[type]].icon} alt="Game Icon" />
            {gamesProps[GamesType[type]].name}
          </p>
        </Header>
      </MobileHeader>
    </Container>
  );
};
